module.exports = __webpack_public_path__ + "static/img/42.aeb7081.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/ADDomain/42.png
// module id = PrKZ
// module chunks = 1